document.addEventListener('DOMContentLoaded', function () {
	const switcher = document.querySelector('.language-switcher');
	if (!switcher) return;
	
	const switcherBtn = switcher.querySelector('.language-switcher__title');
	const currencyList = switcher.querySelector('.language-switcher__list');
	const currencyItems = currencyList.querySelectorAll('.language-switcher__language');
	const currencyCookieName = 'currency';
	
	function setCookie(name, value, days = 7) {
		document.cookie = `${name}=${value}; path=/; max-age=${60 * 60 * 24 * days}`;
	}
	
	function getCookie(name) {
		return document.cookie.split('; ').find(row => row.startsWith(name + '='))?.split('=')[1] ?? null;
	}
	
	function updateCoursePrices(code) {
		const prices = document.querySelectorAll('.course-price');
		const symbol = {
			eur: '€',
			usd: '$',
			gbp: '£',
			sar: 'SAR'
		}[code.toLowerCase().trim()] ?? '€';
		
		prices.forEach(el => {
			const datasetKey = code.toLowerCase().trim();
			const value = el.getAttribute(`data-${datasetKey}`);
			
			if (value) {
				const numberEl = el.querySelector('.price-number');
				if (numberEl) numberEl.textContent = parseFloat(value).toFixed(2);
				
				const wrapper = el.parentElement;
				const symbolEl = wrapper.querySelector('.currency-symbol');
				if (symbolEl) {
					symbolEl.textContent = symbol;
				}
			}
		});
		
		window.updateCourseLocationPrices();
	}
	
	function updateSwitcherUI(selectedText) {
		let match = selectedText.match(/^([€$£SAR])\s?(.*)$/);
		let symbol = match?.[1] ?? '';
		let code = match?.[2] ?? selectedText;
		if (symbol === 'S') {
			symbol = 'SAR';
		}
		
		if (symbol !== 'SAR') {
			switcherBtn.querySelector('.language-switcher__value-title').innerHTML = `
		<span class="currency-symbol">${symbol}</span> ${code}
	`;
		} else {
			switcherBtn.querySelector('.language-switcher__value-title').innerHTML = `
		<span class="currency-symbol"></span> ${symbol}
	`;
		}
		
		const allCurrencies = {
			USD: '$',
			GBP: '£',
			SAR: 'SAR',
			EUR: '€',
		};
		
		currencyList.innerHTML = '';
		
		Object.entries(allCurrencies).forEach(([currCode, currSymbol]) => {
			if (currCode.toLowerCase().trim() === code.toLowerCase().trim()) return;
			
			const li = document.createElement('li');
			li.className = 'language-switcher__item-list';
			
			const btn = document.createElement('button');
			btn.type = 'button';
			btn.className = 'language-switcher__language';
			if (currSymbol !== 'SAR') {
				btn.innerHTML = `<span><span class="currency-symbol">${currSymbol}</span> ${currCode}</span>`;
			} else {
				btn.innerHTML = `<span><span class="currency-symbol"></span> ${currCode}</span>`;
			}
			
			li.appendChild(btn);
			currencyList.appendChild(li);
		});
		
		const updatedCurrencyItems = currencyList.querySelectorAll('.language-switcher__language');
		updatedCurrencyItems.forEach(button => {
			button.addEventListener('click', () => {
				const selected = button.textContent.trim();
				const currencyCode = selected.replace(/[^A-Z]/g, '');
				setCookie(currencyCookieName, currencyCode);
				updateSwitcherUI(`${allCurrencies[currencyCode]} ${currencyCode}`);
			});
		});
		
		updateCoursePrices(code);
	}
	
	const savedCurrency = getCookie(currencyCookieName);
	if (!savedCurrency) {
		const activeText = switcherBtn.querySelector('.language-switcher__value-title').textContent.trim();
		const code = activeText.replace(/[^A-Z]/g, '') || 'EUR';
		setCookie(currencyCookieName, code);
		updateCoursePrices(code);
	} else {
		updateCoursePrices(savedCurrency);
	}
	
	currencyItems.forEach(button => {
		button.addEventListener('click', () => {
			const selected = button.textContent.trim();
			const currencyCode = selected.replace(/[^A-Z]/g, '');
			setCookie(currencyCookieName, currencyCode);
			updateSwitcherUI(selected);
		});
	});
});